import { render, staticRenderFns } from "./ButtonMenuComponent.vue?vue&type=template&id=7233ddd4"
import script from "./ButtonMenuComponent.vue?vue&type=script&lang=js"
export * from "./ButtonMenuComponent.vue?vue&type=script&lang=js"
import style0 from "./ButtonMenuComponent.vue?vue&type=style&index=0&id=7233ddd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports